import { rem } from './../functions/units';

/**
Spacing Assignment

----------------------------------------------------
  Controls - button--smx, form controls
----------------------------------------------------
**/
var spacing = {
  spacingControlHeightSm: 36,
  spacingControlHeight: 40 /** this needs to be raw number for PL calcs. **/,
  spacingControlHeightLg: 44 /** large **/,
  spacingControlHeightXl: 52,
  spacingControlHeightTextarea: 48,
  spacingControlHeightTouchOption: 34,
  spacingControlPad: rem(4, 12),
  spacingActionHeightXs: 28,
  spacingActionWidthXs: 28,
  spacingActionPadXs: rem(0, 8),
  spacingActionHeightSm: 36,
  spacingActionWidthSm: 0,
  spacingActionPadSm: rem(0, 20),
  spacingActionHeightMd: 44,
  spacingActionWidthMd: 112,
  spacingActionPadMd: rem(0, 32),
  spacingActionHeightLg: 52,
  spacingActionWidthLg: 52,
  spacingActionPadLg: rem(0, 56),
  spacingActionHeightXl: 60,
  spacingActionWidthXl: 60,
  /**
  ----------------------------------------------------
   Containers
  ----------------------------------------------------
  **/
  spacingContainerLabelVr: 8
};
export default spacing;